import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TEAM } from "@/data";
import { Reveal, SectionHead } from "@/components/Reveal";

const initials = (name) => name.replace("Dr ", "").split(" ").filter((w) => w.length > 2).map((w) => w[0]).join("");

const TeamCard = ({ member }) => (
  <article data-testid={`team-card-${member.slug}`} className="flex h-full flex-col overflow-hidden rounded-xl border border-stone/80 bg-cream">
    <div className="relative aspect-[4/5] bg-sage">
      {member.photo ? (
        <img src={member.photo} alt={member.name} className="h-full w-full object-cover object-top" loading="lazy" />
      ) : (
        <div data-testid={`team-photo-placeholder-${member.slug}`} className="flex h-full w-full flex-col items-center justify-center gap-3">
          <span className="flex h-24 w-24 items-center justify-center rounded-full border border-stone bg-cream font-serif text-3xl text-forest">{initials(member.name)}</span>
          <span className="font-sans text-xs text-fern">Photo coming soon</span>
        </div>
      )}
    </div>
    <div className="flex flex-1 flex-col px-7 pb-7 pt-6">
      <h3 className="font-serif text-3xl leading-snug text-ink">{member.name}</h3>
      <p className="mt-1 font-sans text-base text-fern">{member.title}</p>
      <p className="mt-4 flex-1 font-sans text-base leading-relaxed text-fern">{member.summary}</p>
      <Link to="/about" data-testid={`team-link-${member.slug}`} className="group mt-6 inline-flex items-center gap-2 font-sans text-sm font-medium text-forest">
        Meet {member.name.split(" ").slice(-1)[0] === "Stejskal" ? "Dr Stejskal" : "Dr Gupta"}
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
      </Link>
    </div>
  </article>
);

const Team = () => (
  <section id="team" data-testid="team-section" className="bg-cream py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <SectionHead dark overline="Our team" title={<>Two dentists, <span className="italic text-fern">one very familiar front door.</span></>} />
      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-12">
        {TEAM.map((m, i) => (
          <Reveal key={m.slug} delay={0.08 * i} y={24}>
            <TeamCard member={m} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
